import React, { useState } from 'react';
import { Helmet } from "react-helmet";
import "App.css";
import "styles/global.css";
import AppRoutes from 'routes';
import { ToastContainer } from 'react-toastify';
import "react-toastify/dist/ReactToastify.css";
import { WebSocketProvider } from 'context/WebSocketContext';
import { AuthProvider } from 'context/AuthContext';
import WebSocketNotificationListener from 'components/WebSocketNotificationListener';
// import SubscriptionChecker from './components/SubscriptionChecker';
// import publicRoutes from 'routes/publicRoutes';
// import { useLocation } from 'react-router';

function App() {

    // const [subscriptionActive, setSubscriptionActive] = useState(true);

    // const handleSubscriptionStatus = (isActive) => {
    //   setSubscriptionActive(isActive);
    // };

    // const location = useLocation();
    // const publicPaths = publicRoutes.map(route => route.path);

    // if (!subscriptionActive && !publicPaths.includes(location.pathname)) {
    //   // Render only the blank page with the warning message
    //   return (
    //     <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh', backgroundColor: 'black' }}>
    //       <h1 style={{ color: 'white' }}>Your subscription has expired. Please renew to continue.</h1>
    //     </div>
    //   );
    // }

    // WebSocket service URL - replace with your external WebSocket service URL
    const wsUrl = process.env.REACT_APP_WEBSOCKET_URL ?? "wss://dev-api.storymetrics.ai/story/v1/ws/notifications";
// Always use wss:// protocol for WebSockets when connecting to HTTPS servers

    return (
        <AuthProvider>
            <WebSocketProvider wsUrl={wsUrl}>
                <div className="App">
                    {/* <SubscriptionChecker onSubscriptionCheck={handleSubscriptionStatus} /> */}
                    <Helmet>
                        <meta charSet="utf-8" />
                        <title>Storymetrics</title>
                        <link rel="canonical" href="www.codewave.com" />
                    </Helmet>
                    
                    <WebSocketNotificationListener />
                    <AppRoutes />
                    <ToastContainer
                        className={"p-0"}
                        limit={3}
                        stacked={true}
                        newestOnTop
                    />
                </div>
            </WebSocketProvider>
        </AuthProvider>
    );
}

export default App;